import api from "./base";
import { AxiosResponse } from "axios";
import { CouponResultData, CouponResultParams } from "../types/coupon";

export const PostCouponData = (
  params: CouponResultParams
): Promise<AxiosResponse<CouponResultData>> =>
  api.post(`/api/v1/purchase/enforce`, params);
